import React from 'react';
import {withRouter} from "react-router-dom";

class Settings extends React.Component {
    render() {
        return (
            <div className="right-col" role="main">
                <div className="x-panel">
                    <div className="x-title">
                        <h2>Nastavení</h2>
                        <div className="clearfix"/>
                    </div>
                    <div className="x-content">
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(Settings);



/** WEBPACK FOOTER **
 ** ./src/containers/Settings/index.js
 **/